/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_IbanInputs */

const en__field_iban = /** @type {(inputs: _Field_IbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IBAN`)
};

const de__field_iban = /** @type {(inputs: _Field_IbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IBAN`)
};

/**
* | output |
* | --- |
* | "IBAN" |
*
* @param {_Field_IbanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_iban = /** @type {((inputs?: _Field_IbanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_IbanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_iban(inputs)
	return de__field_iban(inputs)
});